import { PANEL } from '../EPConstants';
export function getPanelFromSidebarOptions(sidebarOptions, panelName) {
  return sidebarOptions.find(sidebarOption => sidebarOption.type === PANEL && sidebarOption.panelName === panelName);
}